<template>
  <div>
    <Header :coverPhoto="coverPhoto"></Header>
<!--    <div class="banner">-->
<!--      <img src="@/assets/images/banner4.png" alt="">-->
<!--    </div>-->
    <div class="honor">
      <div class="title">
        <h3>公司荣誉 / Company honor</h3>
        <p>凝结了我们多年的努力</p>
      </div>
      <div class="honor-container">
        <ul>
          <li v-for="(honor, idx) in honorList" :key="idx" :title="honor.newsContentTitle" @click="goDetail(honor.newsContentLink, honor.templateRecordUrl, honor.newsContentType, honor.newsContentContent)">
            <div class="honor-name">{{ honor.newsContentTitle }}</div>
            <img :src="requestUrl + '/news/route/file/downloadfile/true/' + honor.newsContentCoverList" alt="">
            <p>{{ honor.newsContentSummary }}</p>
            <span>REAM MORE</span>
          </li>
        </ul>
      </div>
      <div class="pager" v-if="page.totalPage > 1">
        <span @click="paging(1)">首页</span>
        <span @click="paging(page.page - 1)" v-if="page.page > 1">上一页</span>
        <ul v-if="page.totalPage > 0 && page.totalPage <= 5">
          <li v-for="cpage in page.totalPage" :class="{'active': page.page == cpage}" :key="cpage" @click="paging(cpage)">
            {{cpage}}
          </li>
        </ul>
        <ul v-if="page.totalPage > 5">
          <li v-if="page.page < 3" v-for="cpage in 5" :class="{'active': page.page == cpage}" :key="cpage" @click="paging(cpage)">
            {{cpage}}
          </li>
          <li v-if="page.page > page.totalPage - 2" v-for="cpage in 5" :class="{'active': page.page == (page.totalPage - 5 + cpage)}" :key="cpage" @click="paging(page.totalPage - 5 + cpage)">
            {{page.totalPage - 5 + cpage}}
          </li>
          <li v-if="page.page >= 3 && page.page <= page.totalPage - 2" v-for="cpage in 5" :class="{'active': page.page == (page.page - (3 - cpage))}" :key="cpage" @click="paging(page.page - (3 - cpage))">
            {{page.page - (3 - cpage)}}
          </li>
        </ul>
        <span @click="paging(page.page + 1)" v-if="page.page < page.totalPage">下一页</span>
        <span @click="paging(page.totalPage)">尾页</span>
      </div>
    </div>
    <div class="loading" v-if="isLoading">
      <img src="@/assets/images/loading.gif" alt="">
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/assets/components/Header'
import Footer from '@/assets/components/Footer'
import url from '@/assets/public/url'
import axios from 'axios'
export default {
  name: "Honor",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      requestUrl: url.url,
      honorList: [],
      isLoading: false,
      page: {
        page: 1,
        rows: 1,
        totalPage: 10,
        newsDirectoriesId: 'a6674c61-ff68-4364-a9c4-61af3e4a3b58',
      },
      coverPhoto: ''
    }
  },
  methods: {
    getHonor: function () {
      var self = this
      self.isLoading = true
      axios.get(self.requestUrl + '/news/app/newscontent/listpagenewscontentrelease', {
        params: self.page
      }).then(function (res) {
        for (var i = 0; i < res.data.rows.length; i++) {
          res.data.rows[i].newsContentCoverList = res.data.rows[i].newsContentCoverList[0].contentCoverId
        }
        self.honorList = res.data.rows
        self.page.page = res.data.page
        self.page.totalPage = Math.ceil(res.data.total / self.page.rows)
        self.isLoading = false
      })
    },
    paging: function (page) {
      this.page.page = page
      // this.isLoading = true
      this.getHonor()
    },
    goDetail: function (link, url, type, outlink) {
      if (type === '6') {
        window.open(outlink)
      } else {
        window.location.href = this.requestUrl + '/' +url
      }
    },
    // 获取版块介绍
    getBoxIntro: function () {
      var self = this
      axios.get(self.requestUrl + '/news/app/newsdirectories/getnewsdirectoriesbyidrelease/a2c3ed88-5ea4-4a60-8af6-f25733e6886f').then(function (res) {
        self.coverPhoto = res.data.directoriesPhoto
      })
    },
  },
  mounted() {
    this.getHonor()
    this.getBoxIntro()
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import "~styles/public.styl"
.loading
  position fixed
  top 50%
  left 50%
  transform translate(-50%, -50%)
  background rgba(255,255,255,0.6)
  padding 30px
  border-radius 10px
  box-shadow 0 0 17px #DEDEDE
.banner, .banner img
  width 100%
  height 400px
.honor
  width 1200px
  margin 35px auto
  .title
    text-align center
    padding 25px 0
    border-bottom 1px solid $main-blue
    margin-bottom 50px
    h3
      font-size 28px
      color #666
      font-weight normal
      margin-bottom 15px
    p
      font-size 14px
      color #999
  .honor-container
    ul
      min-height 500px
      &:after
        content ''
        display block
        clear both
      li
        float left
        width 370px
        margin-right 45px
        margin-bottom 40px
        border-radius 5px
        border-bottom 1px solid #eee
        padding-bottom 10px
        cursor pointer
        &:nth-child(3n)
          margin-right 0
        .honor-name
          font-size 18px
          color #4c4c4c
          font-weight bold
          margin-bottom 15px
        img
          width 100%
          height 220px
        p
          font-size 14px
          line-height 25px
          color #4c4c4c
        span
          font-size 14px
          color $main-blue
.pager
  text-align center
  font-size 0
  margin-bottom 20px
  span
    display inline-block
    padding 0 15px
    line-height 30px
    color #333
    font-size 14px
    margin 0 5px
    vertical-align middle
    cursor pointer
    border 1px solid #CCCCCC
  ul
    display inline-block
    overflow hidden
    vertical-align middle
    li
      width 30px
      line-height 30px
      float left
      margin-right 10px
      cursor pointer
      text-align center
      font-size 14px
      color #333
      border 1px solid #CCCCCC
      &.active
        color: $main-blue
        border 1px solid $main-blue
        box-sizing border-box
      &:last-child
        margin 0
</style>



// WEBPACK FOOTER //
// src/pages/Honor/Honor.vue